(() => {
  'use strict';
  let opener;
  const openDialog = (dialog, trigger) => {
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    opener = trigger;
    dialog.showModal();
    if (dialog.id === 'SearchDialog') dialog.querySelector('input[type="search"]')?.focus();
    return true;
  };
  document.addEventListener('click', (event) => {
    const search = event.target.closest('[data-search-open]');
    const menu = event.target.closest('[data-menu-open]');
    if (search && openDialog(document.getElementById('SearchDialog'), search)) event.preventDefault();
    if (menu) openDialog(document.getElementById('MobileMenu'), menu);
    const close = event.target.closest('[data-dialog-close]');
    if (close) close.closest('dialog')?.close();
    if (event.target instanceof HTMLDialogElement && ['SearchDialog','MobileMenu'].includes(event.target.id)) {
      const r = event.target.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) event.target.close();
    }
    const shade = event.target.closest('[data-shade-choice]');
    if (shade) {
      const studio = shade.closest('[data-shade-studio]');
      const image = studio.querySelector('.shade-main-image');
      image.removeAttribute('srcset');
      image.src = shade.dataset.image;
      image.alt = shade.dataset.name;
      studio.querySelector('[data-shade-name]').textContent = shade.dataset.name;
      studio.querySelector('[data-shade-price]').textContent = shade.dataset.price;
      studio.querySelector('[data-shade-note]').textContent = shade.dataset.note;
      studio.querySelector('[data-shade-link]').href = shade.dataset.href;
      studio.querySelectorAll('[data-shade-choice]').forEach(button => {
        button.setAttribute('aria-pressed', String(button === shade));
        button.classList.toggle('is-active', button === shade);
      });
    }
  });
  document.querySelectorAll('#SearchDialog, #MobileMenu').forEach(dialog => dialog.addEventListener('close', () => opener?.focus()));
  const closeAccount = (restoreFocus = false) => {
    const menu = document.querySelector('[data-account-menu][open]');
    if (!menu) return;
    menu.open = false;
    if (restoreFocus) menu.querySelector('summary').focus();
  };
  document.addEventListener('click', (event) => {
    const menu = event.target.closest('[data-account-menu]');
    if (!menu || event.target.closest('a')) closeAccount();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && document.querySelector('[data-account-menu][open]')) {
      event.preventDefault();
      closeAccount(true);
    }
  });
  document.addEventListener('focusin', (event) => {
    if (!event.target.closest('[data-account-menu]')) closeAccount();
  });
  document.querySelectorAll('[data-language-popover]').forEach(popover => {
    popover.addEventListener('beforetoggle', event => {
      if (event.newState === 'open') closeAccount();
    });
    popover.addEventListener('toggle', () => {
      if (!popover.matches(':popover-open')) return;
      const trigger = document.getElementById(`${popover.id}-trigger`);
      const anchor = trigger.getBoundingClientRect();
      const panel = popover.getBoundingClientRect();
      popover.style.top = `${Math.max(12, Math.min(anchor.bottom + 8, innerHeight - panel.height - 12))}px`;
      popover.style.left = `${Math.max(12, Math.min(anchor.right - panel.width, innerWidth - panel.width - 12))}px`;
    });
  });
  const syncLanguageForms = (root = document) => {
    root.querySelectorAll('[data-language-form]').forEach(form => {
      if (form.dataset.languageReady) return;
      form.dataset.languageReady = 'true';
      form.addEventListener('submit', () => {
        let returnTo = form.querySelector('input[name="return_to"]');
        if (!returnTo) {
          returnTo = document.createElement('input');
          returnTo.type = 'hidden';
          returnTo.name = 'return_to';
          form.append(returnTo);
        }
        returnTo.value = location.pathname + location.search + location.hash;
      });
    });
  };
  syncLanguageForms();
  document.addEventListener('shopify:section:load', event => syncLanguageForms(event.target));
  const closeLanguage = () => document.querySelectorAll('[data-language-popover]:popover-open').forEach(popover => popover.hidePopover());
  window.addEventListener('resize', closeLanguage);
  window.addEventListener('scroll', closeLanguage, { passive: true });
  const footerMobile = window.matchMedia('(max-width: 749px)');
  const syncFooterGroups = () => document.querySelectorAll('[data-footer-group]').forEach(group => {
    group.open = !footerMobile.matches;
    group.querySelector('summary').tabIndex = footerMobile.matches ? 0 : -1;
  });
  syncFooterGroups();
  footerMobile.addEventListener('change', syncFooterGroups);
  document.addEventListener('shopify:section:load', syncFooterGroups);
})();
